import {
    PROJECTS_COMMERCIAL_SUCCESSFUL_FETCH,
    PROJECTS_PARENTS_SUCCESSFUL_FETCH,
    PROJECTS_SUCCESSFUL_YEARSTERM, PROJECTS_SUCCESSFUL_CAMPAIGN
} from 'reducers/constants';

const initialState = {
    items: [],
    parents: [],
    item: {},
    yearsTerm: [],
    campaign: []

}

export default function (state = initialState, action) {
    switch (action.type) {
        case PROJECTS_COMMERCIAL_SUCCESSFUL_FETCH:
            return {
                ...state,
                items: action.payload
            }

        case PROJECTS_PARENTS_SUCCESSFUL_FETCH:
            return {
                ...state,
                parents: action.payload
            }

        case PROJECTS_SUCCESSFUL_YEARSTERM:
            return {
                ...state,
                yearsTerm: action.payload.slice()
            }

        case PROJECTS_SUCCESSFUL_CAMPAIGN:
            return {
                ...state,
                campaign: action.payload.slice()
            }

        default:
            return state;

    }

}


// WEBPACK FOOTER //
// ./src/reducers/project/projectReducer.js